// import
import React from 'react';
import Dashboard from "views/Dashboard/Dashboard.js";
import Tables from "views/Dashboard/Tables.js";
import Billing from "views/Dashboard/Billing.js";
import Cities from "views/Dashboard/Cities.js";
import Categories from "views/Dashboard/Categories.js";
import Sizes from "views/Dashboard/Sizes.js";
import Colors from "views/Dashboard/Colors.js";
import Users from "views/Dashboard/Users.js";
import RolesPermissions from "views/Dashboard/RolesPermissions.js";
import Companies from "views/Dashboard/Companies.js";
import Products from "views/Dashboard/Products.js";
import OTP from "views/Dashboard/OTP.js";
// Helper to detect company session
import { getUserData } from "./utils/auth";

import Profile from "views/Dashboard/Profile.js";
import SignIn from "views/Pages/SignIn.js";
import SignUp from "views/Pages/SignUp.js";

import {
  HomeIcon,
  StatsIcon,
  CreditIcon,
  PersonIcon,
  DocumentIcon,
  RocketIcon,
  SupportIcon,
  CategoriesIcon,
  SizesIcon,
  ColorsIcon,
  CitiesIcon,
  SettingsIcon,
  CompaniesIcon,
  CartIcon,
  OTPIcon,
} from "components/Icons/Icons";

const isCompanySession = (() => {
  try {
    const u = getUserData();
    return !!(u && (u.logo || typeof u.user_id !== 'undefined'));
  } catch { return false; }
})();

var dashRoutes = [
  // Dashboard route kept for admins; companies will be redirected to companies
  !isCompanySession ? {
    path: "/dashboard",
    name: "لوحة القيادة",
    icon: <HomeIcon color='inherit' />,
    component: Dashboard,
    layout: "/admin",
  } : null,
  {
    path: "/cities",
    name: "المدن",
    icon: <CitiesIcon color='inherit' />,
    component: Cities,
    layout: "/admin",
  },
  {
    path: "/categories",
    name: "الفئات",
    icon: <CategoriesIcon color='inherit' />,
    component: Categories,
    layout: "/admin",
  },
  {
    path: "/sizes",
    name: "المقاسات",
    icon: <SizesIcon color='inherit' />,
    component: Sizes,
    layout: "/admin",
  },
  {
    path: "/colors",
    name: "الألوان",
    icon: <ColorsIcon color='inherit' />,
    component: Colors,
    layout: "/admin",
  },
  {
    path: "/users",
    name: "المستخدمين",
    icon: <PersonIcon color='inherit' />,
    component: Users,
    layout: "/admin",
  },
  {
    path: "/roles-permissions",
    name: "الأدوار والصلاحيات",
    icon: <SettingsIcon color='inherit' />,
    component: RolesPermissions,
    layout: "/admin",
  },
  {
    path: "/companies",
    name: isCompanySession ? "الشركة" : "الشركات",
    icon: <CompaniesIcon color='inherit' />,
    component: Companies,
    layout: "/admin",
  },
  {
    path: "/products",
    name: "المنتجات",
    icon: <CartIcon color='inherit' />,
    component: Products,
    layout: "/admin",
  },
  // OTP route - admin only, not for company sessions
  !isCompanySession ? {
    path: "/otp",
    name: "OTP",
    icon: <OTPIcon color='inherit' />,
    component: OTP,
    layout: "/admin",
  } : null,
  {
    path: "/signin",
    name: "تسجيل الدخول",
    component: SignIn,
    layout: "/auth",
  },
  {
    path: "/signup",
    name: "إنشاء حساب",
    component: SignUp,
    layout: "/auth",
  },
  /**
  {
    path: "/tables",
    name: "الجداول",
    icon: <StatsIcon color='inherit' />,
    component: Tables,
    layout: "/admin",
  },
  {
    path: "/billing",
    name: "الفواتير",
    icon: <CreditIcon color='inherit' />,
    component: Billing,
    layout: "/admin",
  },
  */
].filter(Boolean);
export default dashRoutes;
